import React from 'react';

const RectangleSvg = ({ shapeInfo, outline, drawOutline, handleClick, index, hiddenIndex, isDrawInEdit }: any) => {
  if (drawOutline) {
    let listPoint: any = [];
    listPoint.push({
      x: shapeInfo?.x,
      y: shapeInfo?.y,
    });

    listPoint.push({
      x: shapeInfo?.x,
      y: shapeInfo?.y + shapeInfo?.height,
    });

    listPoint.push({
      x: shapeInfo?.x + shapeInfo?.width,
      y: shapeInfo?.y + shapeInfo?.height,
    });

    listPoint.push({
      x: shapeInfo?.x + shapeInfo?.width,
      y: shapeInfo?.y,
    });

    return (
      <>
        {hiddenIndex === -1 && index === 0 && isDrawInEdit ? (
          <path
            d={`M ${listPoint
              .map((pointData: any) => {
                return `${pointData?.x} ${pointData?.y}`;
              })
              .join(' L ')} Z`}
            transform={shapeInfo?.transform ? `translate(${shapeInfo?.transform?.x},${shapeInfo?.transform?.y})` : ''}
            stroke="black"
            strokeWidth={11}
            fill={'none'}
          />
        ) : (
          <></>
        )}
        <path
          d={`M ${listPoint
            .map((pointData: any) => {
              return `${pointData?.x} ${pointData?.y}`;
            })
            .join(' L ')} Z`}
          transform={shapeInfo?.transform ? `translate(${shapeInfo?.transform?.x},${shapeInfo?.transform?.y})` : ''}
          stroke="grey"
          strokeWidth={1}
          fill={'none'}
        />
      </>
    );
  } else {
    return (
      <g
        id={index}
        onClick={handleClick}
        transform={shapeInfo?.transform ? `translate(${shapeInfo?.transform?.x},${shapeInfo?.transform?.y})` : ''}
      >
        <rect
          width={shapeInfo?.width}
          height={shapeInfo?.height}
          x={shapeInfo?.x}
          y={shapeInfo?.y}
          fill={hiddenIndex === -1 && index === 0 && isDrawInEdit ? 'none' : 'none'}
        />
        <image
          x={shapeInfo?.x + (shapeInfo?.outlinePadding ?? 0) - 15}
          y={shapeInfo?.y + (shapeInfo?.outlinePadding ?? 0) - 15}
          width={shapeInfo?.width + 30}
          height={shapeInfo?.height + 30}
          preserveAspectRatio="none"
        />
      </g>
    );
  }
};

export default RectangleSvg;
